<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div class="header-title">
              <h4 class="m-0 title-modal">PEP</h4>
            </div>
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>

          <div class="modal-body">
            <div class="">
              <div class="p-3 pv-5">
                <span class="d-block">
                  DECLARAÇÃO DE PESSOA EXPOSTA POLITICAMENTE ("PEP") - Pessoa
                  exposta politicamente é aquela que desempenha ou tenha
                  desempenhado, nos últimos cinco (5) anos, cargos, empregos ou
                  funções públicas relevantes, no Brasil ou em outros países,
                  territórios e dependências estrangeiros. Isso inclui seus
                  representantes, familiares e outras pessoas de seu
                  relacionamento próximo. Familiarmente, são considerados
                  parentes em linha direta até o primeiro grau, além do cônjuge,
                  companheiro(a), enteado(a). Pessoas de relacionamento próximo
                  abrangem sócios, procuradores e pessoas com as quais se
                  mantenha relacionamento de negócios contínuo. Os
                  representantes signatários desta ficha declaram que os
                  representantes legais e/ou os beneficiários finais mencionados
                  acima estão cientes e de acordo.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
